/**
 * Type d'entité de facturation.
 * Les valeurs correspondent aux codes attendus/renvoyés côté back
 * (cf. attribut typeEntite des préférences de facturation).
 */
export enum TypeEntite {
  Publique = 'Publique',
  PriveeAssujettie = 'PriveeAssujettie',
}
